import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getBestCTR } from '../../../../../redux/actions/reports'
import { IRootState } from '../../../../../redux/types'

interface Item {
  foreign_id: number
  foreign_name: string
  image: string
  value: number
  menu: string
}

interface BestCTR {
  weekCTR: Item[]
  monthCTR: Item[]
}

export default function useBestCTR(): BestCTR {
  const dispatch = useDispatch()
  const { bestCTR } = useSelector((state: IRootState) => state.report)

  useEffect(() => {
    dispatch(getBestCTR())
  }, [])

  return { monthCTR: bestCTR.monthCTR, weekCTR: bestCTR.weekCTR }
}
